import { render } from "./AccessReport.vue?vue&type=template&id=36f3f0b8"
import script from "./AccessReport.vue?vue&type=script&lang=js"
export * from "./AccessReport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\yasukochi\\Work\\11_Marron\\00_Working\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__